// extracted by mini-css-extract-plugin
module.exports = {"list":"CaptionData_list__2i9MP","article":"CaptionData_article__2tMjv","title":"CaptionData_title__1Wcwz","content":"CaptionData_content__BkKg0","load":"CaptionData_load__7HAto"};